import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { OrdenCompraService } from 'src/app/services/orden-compra.service';


@Component({
  selector: 'app-modal-listado-ordenes-compra-usuario',
  templateUrl: './modal-listado-ordenes-compra-usuario.component.html',
  styleUrls: ['./modal-listado-ordenes-compra-usuario.component.scss']
})
export class ModalListadoOrdenesCompraUsuarioComponent implements OnInit {
  public nombreUsuario: string = '';
  public dataSource: any;
  public displayedColumns: string[];
  public isLoadingResults = false;
  pageIndex: number = 0;
  pageSize: number = 10;
  length: number;
  searchString: string = '';
  public dataInput: any;

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    public ordenCompraSvc: OrdenCompraService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ModalListadoOrdenesCompraUsuarioComponent>
  ) {
    this.dataInput = data;
    console.log('los datos de ingreso son: ', data);

    let ELEMENT_DATA: any[] = [];
    this.displayedColumns = ['nombre', 'fechaAModificar', 'fechaNueva','valor','comentario', 'estado'];

    this.dataSource = new MatTableDataSource<any>(ELEMENT_DATA);
  }

  ngOnInit(): void {
    // this.inicarFormulario();

    this.nombreUsuario = this.dataInput.nombre;
    this.getListadoDetallesOrden(0, 10);
  }

  getListadoDetallesOrden(page: number, numReg: number) {
    this.ordenCompraSvc
      .getOrdenesCompraPorUsuario({page, numReg, usuarioId:this.dataInput.id})
      .subscribe((result) => {
        console.log(result);

        this.dataSource = new MatTableDataSource<any>(result[0]);
        this.pageIndex = page;
        this.pageSize = numReg;
        this.length = result[1];
        this.isLoadingResults = false;
      });
  }

  getServerData(event: PageEvent) {
    console.log('click evento paginator', event);
    this.getListadoDetallesOrden(event.pageIndex, event.pageSize);
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

}
